import React, { useState } from "react";
import { Card, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaMoneyCheckAlt,
  FaHistory,
  FaUniversity,
  FaThumbsUp,
  FaHandshake,
} from "react-icons/fa";
import { BsCalendarCheck } from "react-icons/bs";
import PaymentActivityModal from "../BorrowerDashboard/PaymentActivityModal";
import RequestPayOffModal from "./RequestPayOffModal";
import { useDispatch } from "react-redux";
import { setManualSelectedAccount } from "../../../store/reducers/accountSlice";

function Payments({ setRefreshTable }) {
  const [show, setShow] = useState(false);
  const [payOffModal, setPayOffModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Card className="p-4 border-primary h-100 paymentsSection">
      <h5 className="mb-4 px-3">Payments</h5>
      <Row className="text-center g-4">
        {[
          {
            icon: FaMoneyCheckAlt,
            label: "Same Day Payment",
            onClick: () => {
              navigate("/same-day-payment");
              dispatch(setManualSelectedAccount({}));
            },
            tooltip: "Make a payment that posts on the same business day.",
          },
          {
            icon: FaMoneyCheckAlt,
            label: "One Time Payment",
            onClick: () => {
              navigate("/one-time-payment");
              dispatch(setManualSelectedAccount({}));
            },
            tooltip: "Schedule a one-time payment for your loan or balance.",
          },
          {
            icon: FaHistory,
            label: "Payment History",
            condition: false,
            onClick: () => setShow((prev) => !prev),
            tooltip: "View your past payments, dates, and transaction details.",
          },
          // { icon: FaThumbsUp, label: "Favorites", condition: true },
          {
            icon: FaUniversity,
            label: "Manage Banking",
            condition: false,
            onClick: () => navigate("/manage-banking"),
            tooltip: "Add or manage your linked bank accounts.",
          },
          {
            icon: FaHandshake,
            label: "Request Payoff",
            condition: false,
            onClick: () => setPayOffModal((prev) => !prev),
            tooltip:
              "Request a full payoff quote including remaining balance and fees.",
          },
          {
            icon: BsCalendarCheck,
            label: "Recurring ACH",
            onClick: () => navigate("/ach-payment"),
            tooltip: "Set up or manage automatic recurring payments.",
          },
        ].map((item, index) => (
          <Col
            key={index}
            xs={4}
            className="d-flex flex-column align-items-center"
          >
            <ComingSoonWrapper
              condition={item.condition}
              label={item.label}
              tooltip={item.tooltip}
            >
              <div
                className="d-flex justify-content-center align-items-center bg-light rounded-circle hover-effect"
                role="button"
                style={{
                  width: "70px",
                  height: "70px",
                  padding: "10px",
                }}
                onClick={item?.onClick && item.onClick}
                // title={item.tooltip}
              >
                <item.icon
                  size={35}
                  className={!item?.condition ? "text-primary" : "text-light"}
                />
              </div>
            </ComingSoonWrapper>
            <p className="small mt-2">{item.label}</p>
          </Col>
        ))}
      </Row>
      <PaymentActivityModal show={show} setShow={setShow} showSelect={true} />
      <RequestPayOffModal
        payOffModal={payOffModal}
        setPayOffModal={setPayOffModal}
        refreshTable={() => setRefreshTable((prev) => !prev)}
      />
    </Card>
  );
}

export default Payments;

export const ComingSoonWrapper = ({
  children,
  condition = false,
  label,
  tooltip,
  show = true,
}) => {
  return show && condition ? (
    <OverlayTrigger
      key={label}
      // trigger={"hover"}
      placement={"top"}
      overlay={<Tooltip id={`tooltip-${label}`}>Coming soon!</Tooltip>}
    >
      {children}
    </OverlayTrigger>
  ) : show && !condition ? (
    // children
    <OverlayTrigger
      key={label}
      // trigger={"hover"}
      placement={"top"}
      overlay={<Tooltip id={`tooltip-${label}`}>{tooltip}</Tooltip>}
    >
      {children}
    </OverlayTrigger>
  ) : (
    children
  );
};
